import { observer } from 'mobx-react'
import React, { ReactNode } from 'react'
import { TouchableOpacity, View, ViewStyle } from 'react-native'
import { Radio, RadioProps } from '@ui-kitten/components'

import { composeStyle } from '../helpers'
import { BtText } from './BtText'

interface IBtRadioGroupProps {
  model?: any
  name?: string
  options: { label: string; value: any }[]
  value?: any
  onChange?: (value: any) => void
  disabled?: boolean
  groupStyle?: any
  radioStyle?: any
  testID?: string
  labelStyle?: any
  error?: string | null
}

export const BtRadioButton = ({
  checked,
  onPress,
  label,
  disabled = false,
  labelLeft = false,
  containerStyle,
  radioProps,
  children,
  testID = '',
  labelStyle,
}: {
  checked: boolean
  onPress: () => void
  label?: string
  disabled?: boolean
  labelLeft?: boolean
  containerStyle?: ViewStyle
  children?: ReactNode
  radioProps?: RadioProps
  testID?: string
  labelStyle?: any
}) => {
  const styleLabel = composeStyle(
    labelLeft ? { marginRight: 10 } : { marginLeft: 10 },
    { fontSize: 16 },
    labelStyle,
  )
  return (
    <TouchableOpacity
      disabled={disabled}
      style={composeStyle(
        { flexDirection: 'row', alignItems: 'center', paddingVertical: 10 },
        containerStyle,
      )}
      onPress={onPress}
      testID={testID}
    >
      {labelLeft && (
        <BtText style={{ marginRight: 10, fontSize: 16 }}>{label}</BtText>
      )}
      <Radio
        onChange={onPress}
        checked={checked}
        disabled={disabled}
        {...radioProps}
      />
      {!labelLeft}
      <BtText style={styleLabel}>{label}</BtText>
      {children}
    </TouchableOpacity>
  )
}

export const BtRadioGroup = observer(
  ({
    model,
    name,
    options,
    value,
    onChange,
    disabled,
    groupStyle,
    radioStyle,
    testID,
    labelStyle,
    error,
  }: IBtRadioGroupProps) => {
    const setValue = (e) => {
      if (onChange) {
        onChange(e)
      }
      if (model && name) {
        model.setValue(name, e)
      }
    }
    if (model && name) {
      value = model[name]
    }
    return (
      <>
        <View style={groupStyle}>
          {options.map((option) => (
            <View key={option.value}>
              <BtRadioButton
                checked={option.value === value}
                label={option.label}
                onPress={() => setValue(option.value)}
                disabled={disabled}
                containerStyle={radioStyle}
                testID={`${testID || 'radioButton'}.${option.value}`}
                labelStyle={labelStyle}
              />
            </View>
          ))}
        </View>
        {!!error && (
          <p
            style={{
              color: '#dd4a2c',
              fontSize: 12,
              fontWeight: 400,
              fontFamily: 'inherit',
            }}
          >
            {error}
          </p>
        )}
      </>
    )
  },
)
